import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminusuariohome',
  templateUrl: './adminusuariohome.component.html',
  styleUrls: ['./adminusuariohome.component.scss']
})
export class AdminusuariohomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
